import React, { useEffect, useState } from "react";
import { useSidebar } from "../useSidebarProvider";
import { Card } from "./components/Card";
import { dashboardTooltipText, options } from "../../constants/dashboard";
import CustomMultiSelect from "../../components/form-input/multi-select";
import { CountryListDTO } from "../companies/DTO/GenericListDTO";
import { useDispatch, useSelector } from "react-redux";
import * as dashboardActions from "../../redux/dashboard/dashboardActions";
import * as companyActions from "../../redux/companies/companiesAction";
import CustomDateSelect from "../../components/form-input/multi-date-select";
import dropdownIcon from "../../assets/images/dropdownIcon.svg";
import funnelIcon from "../../assets/images/funnelIcon.svg";
import ActiveFunnelIcon from "../../assets/images/activeFunnelIcon.svg";
import DashboardModal from "./components/Modal";

function Dashboard() {
  const { collapsed } = useSidebar();
  const [countryList, setCountryList] = useState<CountryListDTO[]>([]);
  const [countrySearchText, setcountrySearchText] = useState("");
  const [countryLoading, setCountryLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [slectedLable, setslectedLable] = useState("Last 30 Days");
  const [selectedValue, setselectedValue] = useState("Last30Days");
  const [showModal, setShowModal] = useState(false);
  const [dateValue, setDateValue] = useState("");
  const [funnelFilterApplied, setFunnelFilterApplied] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    startDate: "",
    endDate: "",
  });

  const { countryData, analyticsData } = useSelector((state: any) => ({
    countryData: state?.companies?.countries,
    analyticsData: state?.dashboard?.analyticsData,
  }));

  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(companyActions.getAllCountries(countrySearchText)).then(() => {
      setCountryLoading(true);
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setCountryList(countryData);
    setCountryLoading(false);

    //eslint-disable-next-line
  }, [countryLoading]);

  const cards = [
    {
      title: "Visited",
      helpDetails: "Total visitors",
      value: analyticsData?.visited?.count,
      percentage: analyticsData?.visited?.percentage,
      tooltipText: dashboardTooltipText.visited,
    },
    {
      title: "Registered",
      helpDetails: "Total registered users",
      value: analyticsData?.registered?.count,
      percentage: analyticsData?.registered?.percentage,
      tooltipText: dashboardTooltipText.registered,
      conversionRate: analyticsData?.registered?.conversionRate,
    },
    {
      title: "1st product",
      helpDetails: "Companies that created their first product",
      value: analyticsData?.firstProduct?.count,
      percentage: analyticsData?.firstProduct?.percentage,
      tooltipText: dashboardTooltipText.firstProduct,
      conversionRate: analyticsData?.firstProduct?.conversionRate,
    },
    {
      title: "1st invoice",
      value: analyticsData?.firstInvoice?.count,
      percentage: analyticsData?.firstInvoice?.percentage,
      tooltipText: dashboardTooltipText.firstInvoice,
      conversionRate: analyticsData?.firstInvoice?.conversionRate,
    },
    {
      title: "Trialed",
      value: analyticsData?.trialled?.count,
      percentage: analyticsData?.trialled?.percentage,
      tooltipText: dashboardTooltipText.trialled,
      conversionRate: analyticsData?.trialled?.conversionRate,
    },
    {
      title: "Subscribed",
      value: analyticsData?.subscribed?.count,
      percentage: analyticsData?.subscribed?.percentage,
      tooltipText: dashboardTooltipText.subscribed,
      conversionRate: analyticsData?.subscribed?.conversionRate,
    },
    ...(analyticsData?.appClicks?.count !== undefined
      ? [
          {
            title: "App clicks",
            value: analyticsData.appClicks.count,
            percentage: analyticsData.appClicks.percentage,
            tooltipText: dashboardTooltipText.appClicks,
          },
        ]
      : []),
  ];

  const handleSelectAllCountry = () => {
    let refactoredArr;
    if (countryList?.filter((item) => !item.isSelected).length > 0) {
      refactoredArr = countryList.map((item) => {
        return { ...item, isSelected: true };
      });
    } else {
      refactoredArr = countryList.map((item) => {
        return { ...item, isSelected: false };
      });
    }

    setCountryList([...refactoredArr]);
    setcountrySearchText("");
  };
  const handleSelectCountry = (id: string, label: string) => {
    let refactoredArr = countryList.map((item) => {
      if (item.label === label) {
        return { ...item, isSelected: !item.isSelected };
      } else {
        return item;
      }
    });
    setCountryList([...refactoredArr]);
  };

  const getDashboardAnalyticsHandler = (params: any) => {
    dispatch(dashboardActions.getDashboardAnalytics(params));
  };

  useEffect(() => {
    if (selectedDate.startDate && selectedDate.endDate) {
      let params = {
        countries: countryList?.filter((item) => item.isSelected)?.map((item) => item.label),
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate,
        funnelDate: funnelFilterApplied ? dateValue : undefined,
      };
      getDashboardAnalyticsHandler(params);
    }
    //eslint-disable-next-line
  }, [selectedDate]);

  const handleClear = () => {
    let refactoredArr;

    refactoredArr = countryList.map((item) => {
      return { ...item, isSelected: true };
    });

    setCountryList([...refactoredArr]);
    setcountrySearchText("");

    if (selectedDate.startDate && selectedDate.endDate) {
      let params = {
        countries: "",
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate,
      };
      getDashboardAnalyticsHandler(params);
    }
  };
  const handleApply = () => {
    if (selectedDate.startDate && selectedDate.endDate) {
      let params = {
        countries: countryList?.filter((item) => item.isSelected)?.map((item) => item.label),
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate,
        funnelDate: funnelFilterApplied ? dateValue : undefined,
      };
      getDashboardAnalyticsHandler(params);
    }
  };
  const handleConfirm = () => {
    if (selectedDate.startDate && selectedDate.endDate) {
      let params = {
        countries: countryList?.filter((item) => item.isSelected)?.map((item) => item.label),
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate,
        funnelDate: dateValue,
      };
      getDashboardAnalyticsHandler(params);
    }
    setShowModal(false);
    setFunnelFilterApplied(true);
  };

  const handleClearFunnelFiilter = () => {
    if (selectedDate.startDate && selectedDate.endDate) {
      let params = {
        countries: countryList?.filter((item) => item.isSelected)?.map((item) => item.label),
        startDate: selectedDate.startDate,
        endDate: selectedDate.endDate,
      };
      getDashboardAnalyticsHandler(params);
    }
    setDateValue("");
    setShowModal(false);
    setFunnelFilterApplied(false);
  };

  return (
    <div style={{ background: "rgb(242, 243, 248)", height: "100vh" }}>
      <div className="company-wrap row m-0 pb-2" style={{ paddingLeft: !collapsed ? "17.8rem" : "3.5rem ", overflow: "hidden" }}>
        <div className="px-4">
          <div className="dashboard-wrapper pb-4 ">
            <div className="custom-multi-select ">
              <CustomMultiSelect
                options={countryList}
                onSelect={() => {}}
                handleSelectAll={handleSelectAllCountry}
                handleSelectedItem={handleSelectCountry}
                handleSearch={() => {}}
                formField={"COUNTRY"}
                countrySearchText={countrySearchText}
                setCountrySearchText={setcountrySearchText}
                isDashboard={true}
                handleClear={handleClear}
                handleApply={handleApply}
              />
            </div>

            <div className="custom-multi-select">
              <div className={`date-wrapper-main pr-2 ${selectedValue !== "Last30Days" ? "active" : "inactive"}`} onClick={() => setIsOpen(!isOpen)}>
                <div>{selectedValue === "CustomRange" ? `${selectedDate?.startDate}-${selectedDate?.endDate}` : `${slectedLable}`}</div>
                <div>
                  <img src={dropdownIcon} alt="dropdown icon" />
                </div>
              </div>

              <CustomDateSelect
                setselectedValue={setselectedValue}
                selectedValue={selectedValue}
                options={options}
                setslectedLable={setslectedLable}
                slectedLable={slectedLable}
                setSelectedDate={setSelectedDate}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                formField="register"
                filtersView={true}
                isDashboard={true}
              />
            </div>
            <div style={{ cursor: "pointer" }} onClick={() => setShowModal(!showModal)}>
              <img src={funnelFilterApplied ? ActiveFunnelIcon : funnelIcon} alt="funnel icon" />
            </div>
          </div>

          <div className="dashboard_cards_wrapper">
            {cards?.map((card, index) => {
              return (
                <Card
                  key={index}
                  title={card?.title}
                  percentage={card?.percentage}
                  value={card?.value}
                  helpDetails={card?.tooltipText}
                  conversionRate={card?.conversionRate}
                />
              );
            })}

            <DashboardModal
              isOpen={showModal}
              toggle={() => {
                setShowModal(!showModal);
              }}
              cancelText="CLEAR"
              confirmText="APPLY"
              handleClear={handleClearFunnelFiilter}
              onConfirm={handleConfirm}
              title="Conversion Window"
              children={
                <>
                  <p>Select the cutoff date for including conversion data in the funnel</p>
                  <input className="funnel-date-select" type="date" value={dateValue} onChange={(e) => setDateValue(e?.target?.value)} />
                </>
              }
            />
          </div>
        </div>{" "}
      </div>
    </div>
  );
}

export default Dashboard;
